import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tool-tip',
  templateUrl: './tool-tip.component.html',
  styleUrls: ['./tool-tip.component.css']
})
export class ToolTipComponent {
  @Input() translateKey: string;
  show: boolean;

  setTooltipVisibility(visible: boolean): void {
    this.show = visible;
  }
}
